import { Box, Typography, } from "@mui/material";
import ContactForm from "components/Contact/ContactForm";
import PropTypes from "prop-types";
import React from "react";
import Unit from "./Unit.model";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";

function SignUpForm({ unit }) {
  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []
  const { i18n: { language }, } = useTranslation();
  const here         = useLocation().pathname
  const atUnit       = here.includes('unit')
  const isRent = unit?.isRent()
  const type = isRent ? 'rent' : 'sales'
  const status = unit.getStatus();
  const statusId = status?.id || false;

  const campaignIds = {
    "rent": '8a50a77ef0e3cecb56002ca548ac3929',
    "sales": '8285f3e36611de7f525f6916e7ed71b6',
  }

  const showText = moment().isBefore("2025-12-09", "day");

  return (
    <Box id="unit_page_contact_form" sx={{ pt: {xs: 3, lg: 5}, pb: { md: 5, xs: 0 }, px: { xs: 3, lg: 5 } }} >
      <Box sx={{ maxWidth: 684, mx: "auto", }} >
        {
           (isRent && (statusId === 10) || !isRent) && 
                 <ContactForm campaignId={campaignIds[type]} drawerType={''} grid unit={unit}>
          <Box sx={{ mb: 3 }} >
          <Box className="h3" > 
              {/* {
                buttonsLabel?.filter( btn => btn.UILabelProperty ===  
                  // "footerHeading1"
                  "SidefodformularOverskrift"
                )[0]?.Label
              } */}
              {
                language === "da" ? "Er du interesseret i en bolig, eller har du spørgsmål?" : "Are you interested in a home or do you have a question?"
              }
            </Box>
            <br />
            <Box className="paragraph1-regular">
              <div>
                <span>
                  {language === "en"
                    ? "Fill in the form below and one of our partners will contact you by email or phone."
                    : "Udfyld nedenstående formular. Så kontakter en af vores samarbejdspartnere dig på mail eller telefon."
                  }
           <br />
                  {showText && (
                    <>
                      {language === "en"
                        ? " You can also stop by Travbyen on 9th of December and register for a home. Read more at "
                        : " Kom også forbi Travbyen d. 9. december og skriv dig op til en bolig. Læs mere på "
                      }
                      <a
                        className="h5"
                        style={{ textDecoration: "none", color: "inherit" }}
                        href="https://www.travbyen.dk/"
                        target="_blank"
                      >
                        www.travbyen.dk
                      </a>
                    </>
                  )}
                </span>
              </div>
            </Box>
          </Box>
        </ContactForm>
        }
      </Box>
    </Box>
  );
}

SignUpForm.propTypes = {
  unit: PropTypes.instanceOf(Unit).isRequired,
};

export default SignUpForm;
